import React, { Component } from "react";
import { TextField } from '@material-ui/core';

class InputCpf extends Component {

    maskCpf = value => {
        if (!value) {
            return null;
        }
        return value
            .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
            .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
    }
    
    handleCpf = async e => {
        e.target.value = this.maskCpf(e.target.value);
        this.props.onChange(e);
    }

    render() {
        return (
            <TextField
                minLength="12"
                variant={this.props.variant} 
                margin={this.props.margin} 
                fullWidth={this.props.fullWidth} 
                required={this.props.required} 
                label={this.props.label} 
                name={this.props.name}
                disabled={this.props.disabled}
                className={`MuiOutlinedInput-root ${this.props.className}`}
                autoComplete="documento"
                autoFocus
                onChange={this.handleCpf}
                error={this.props.error}
                value={this.maskCpf(this.props.value)}
                inputProps={{ maxLength: 25 }}
            />
        )
    }
}

export default InputCpf;